import { NavLink, useNavigate } from "react-router-dom";
import { ONEGO_LOGO } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import {
    LayoutDashboard,
    Wallet,
    Zap,
    ShoppingCart,
    Truck,
    Banknote,
    Receipt,
    BarChart3,
    Users,
    MapPin,
    Crown,
    LogOut,
} from "lucide-react";

const items = [
    { to: "/dashboard", label: "Overview", icon: LayoutDashboard, end: true },
    { to: "/dashboard/wallet", label: "Wallet", icon: Wallet },
    { to: "/dashboard/sell", label: "Sell services", icon: Zap },
    { to: "/dashboard/procurement", label: "Procurement", icon: ShoppingCart },
    { to: "/dashboard/logistics", label: "Logistics", icon: Truck },
    { to: "/dashboard/nearby", label: "Nearby", icon: MapPin },
    { to: "/dashboard/credit", label: "Credit", icon: Banknote },
    { to: "/dashboard/sales", label: "Sales history", icon: Receipt },
    { to: "/dashboard/analytics", label: "Analytics", icon: BarChart3 },
    { to: "/dashboard/customers", label: "Customers", icon: Users },
    { to: "/dashboard/subscriptions", label: "Subscription", icon: Crown },
];

export default function Sidebar() {
    const { logout, user } = useAuth();
    const navigate = useNavigate();
    return (
        <aside className="hidden lg:flex w-64 shrink-0 flex-col bg-white border-r border-slate-200 sticky top-0 h-screen" data-testid="sidebar">
            <div className="px-6 py-5 border-b border-slate-200">
                <img src={ONEGO_LOGO} alt="OneGo" className="h-9 w-auto" />
            </div>
            <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
                {items.map((it) => {
                    const Icon = it.icon;
                    return (
                        <NavLink
                            key={it.to}
                            to={it.to}
                            end={it.end}
                            data-testid={`sidebar-link-${it.label.toLowerCase().replace(/\s/g, "-")}`}
                            className={({ isActive }) =>
                                `flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-semibold transition-all ${
                                    isActive
                                        ? "bg-onego-navy text-white shadow-sm"
                                        : "text-slate-600 hover:bg-slate-100"
                                }`
                            }
                        >
                            <Icon size={18} />
                            {it.label}
                        </NavLink>
                    );
                })}
            </nav>
            <div className="px-3 py-4 border-t border-slate-200">
                <div className="px-3 py-2 mb-2">
                    <p className="text-xs text-slate-500 truncate" data-testid="sidebar-user-email">{user?.email}</p>
                    <p className="text-sm font-bold text-onego-navy truncate">{user?.business_name || user?.name}</p>
                </div>
                <button
                    onClick={async () => { await logout(); navigate("/"); }}
                    className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-semibold text-slate-600 hover:bg-slate-100"
                    data-testid="sidebar-logout-btn"
                >
                    <LogOut size={18} /> Sign out
                </button>
            </div>
        </aside>
    );
}
